module.exports = (
  $scope,
  $state,
  workflow,
  workflowSteps,
  entity
) ->

  $scope.setWorkflow workflow
  $scope.setSteps $scope.allWorkflowSteps[$scope.workflow.id]

  $scope.entity = entity

  # if we're in the workflow redirect onto the step
  if $state.current.name == 'project.workflow'
    if $scope.steps
      params =
        projectId: $scope.project.id
        workflowId: $scope.workflow.id
        workflowStepId: $scope.steps?[0].id
      $state.go('project.workflow.step', params)
    else
      $scope.error = 'No steps here'
